//
export default [
    {
        text: "#",
        value: "id",
    },
    {
        text: "rut",
        value: "rut",
        format: "rut",
        width: "200px",
    },
    {
        text: "razón social",
        value: "business_name",
    },
    {
        text: "nombre",
        value: "alias_name",
    },
    {
        text: "sucursales",
        value: "branch_offices_address",
        component: {
            type: "chip-list",
        },
    },
    {
        text: "fecha de creación",
        value: "created_at",
        align: "right",
    },
]